webpackJsonp([243769048847541],{

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _navigation = __webpack_require__(13);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _footer = __webpack_require__(12);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _seo = __webpack_require__(38);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	var _seo3 = __webpack_require__(44);
	
	var _seo4 = _interopRequireDefault(_seo3);
	
	var _registerNowLeft = __webpack_require__(23);
	
	var _registerNowLeft2 = _interopRequireDefault(_registerNowLeft);
	
	var _cover = __webpack_require__(19);
	
	var _cover2 = _interopRequireDefault(_cover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Seo = function (_React$Component) {
		(0, _inherits3.default)(Seo, _React$Component);
	
		function Seo() {
			(0, _classCallCheck3.default)(this, Seo);
			return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
		}
	
		Seo.prototype.pageClick = function pageClick(e) {
			document.getElementsByTagName('body')[0].className = '';
		};
	
		Seo.prototype.componentDidMount = function componentDidMount() {
			var mask = document.getElementById('mask');
			mask.addEventListener('touchstart', this.pageClick, false);
		};
	
		Seo.prototype.render = function render() {
			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(_reactHelmet2.default, {
					title: "Jobs For Freelance Writers - UvoCorp.com",
					meta: [{ name: "description", content: "Jobs for freelance writers, writing careers. Apply for a job online with UvoCorp.com. Registration is free." }, { property: 'og:title', content: "Jobs For Freelance Writers - UvoCorp.com" }, { property: 'og:description', content: "Jobs for freelance writers, writing careers. Apply for a job online with UvoCorp.com. Registration is free." }, { property: 'og:site_name', content: "UvoCorp.com" }, { property: 'og:type', content: "website" }, { property: 'og:image', content: _cover2.default }],
					link: [{ rel: 'canonical', href: "https://www.uvocorp.com/jobs_for_writers.html" }] }),
				_react2.default.createElement(
					"div",
					{ className: "header", id: "header" },
					_react2.default.createElement(_navigation2.default, null)
				),
				_react2.default.createElement(
					"div",
					{ className: "wrapper" },
					_react2.default.createElement(
						"div",
						{ className: "inner-header" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h1",
								null,
								"Jobs For Freelance Writers"
							),
							_react2.default.createElement(
								_gatsbyLink2.default,
								{ to: "/register_email.html" },
								"Register now"
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "home-benefits home-block hiring-benefits" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h1",
								null,
								"The benefits you enjoy working as a freelance writer:"
							),
							_react2.default.createElement(
								"ul",
								{ className: "home-benefits-list" },
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-1" },
									_react2.default.createElement(
										"p",
										null,
										"No registration fees"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-2" },
									_react2.default.createElement(
										"p",
										null,
										"High wages"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-3" },
									_react2.default.createElement(
										"p",
										null,
										"Working from home"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-4" },
									_react2.default.createElement(
										"p",
										null,
										"Orders in the sphere ",
										_react2.default.createElement("br", null),
										"of your interest"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-5" },
									_react2.default.createElement(
										"p",
										null,
										"24/7 available ",
										_react2.default.createElement("br", null),
										"support team"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-6" },
									_react2.default.createElement(
										"p",
										null,
										"Payments always ",
										_react2.default.createElement("br", null),
										"on time"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-7" },
									_react2.default.createElement(
										"p",
										null,
										"Manage your time ",
										_react2.default.createElement("br", null),
										"and workload yourself"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "home-pricing-info" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"p",
								null,
								"There is no other company that offers ",
								_react2.default.createElement(
									"strong",
									null,
									"$15"
								),
								"/page written by an ",
								_react2.default.createElement(
									"span",
									{ className: "home-pricing-info-role" },
									"ESL"
								),
								" writer and ",
								_react2.default.createElement(
									"strong",
									null,
									"$26"
								),
								"/page completed by an ",
								_react2.default.createElement(
									"span",
									{ className: "home-pricing-info-role" },
									"ENL"
								),
								" writer."
							),
							_react2.default.createElement(
								_gatsbyLink2.default,
								{ to: "/prices.html" },
								"View Pricing ",
								_react2.default.createElement(
									"svg",
									{ id: "arrow-right", width: "22", height: "22" },
									_react2.default.createElement("path", { fill: "#black", d: "M17.2,10.2l-3.2,3c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2v-1.9H3c-0.2,0-0.3-0.1-0.3-0.3V9.2 C2.8,9,2.9,8.9,3,8.9h10.5V7.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0l3.2,2.9c0.1,0.1,0.1,0.1,0.1,0.2 C17.2,10.1,17.2,10.1,17.2,10.2z" })
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-white hiring seo" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h2",
								null,
								"Writers wanted"
							),
							_react2.default.createElement(
								"div",
								{ className: "row" },
								_react2.default.createElement(
									"div",
									{ className: "col-md-9" },
									_react2.default.createElement(
										"p",
										null,
										"Dear potential ",
										_react2.default.createElement(
											_gatsbyLink2.default,
											{ to: "/" },
											"UVOCORP"
										),
										" writers, we are currently hiring:"
									),
									_react2.default.createElement(
										"ol",
										{ className: "hiring-steps" },
										_react2.default.createElement(
											"li",
											null,
											"Writers who are Native Speakers of English (these writers have exclusive access to orders which need to be written by a Native Speaker of English);"
										),
										_react2.default.createElement(
											"li",
											null,
											"English as a Second Language writers with a profound knowledge in Humanities, Business Studies, Applied, and Social Sciences;"
										),
										_react2.default.createElement(
											"li",
											null,
											"Writers with a profound knowledge in the following disciplines. Working only on them on a permanent basis is our internal separate project:"
										)
									),
									_react2.default.createElement(
										"ul",
										{ className: "hiring-disciplines" },
										_react2.default.createElement(
											"li",
											{ className: "discipline_8" },
											"Accounting"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_15" },
											"Architecture, Building and Planning"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_14" },
											"Biology (and other Life Sciences)"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_13" },
											"Chemistry"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_1" },
											"Engneering"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_10" },
											"Civil Engineering"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_7" },
											"Computer Science"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_5" },
											"IT, Web"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_3" },
											"Finance"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_11" },
											"Mathematics"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_12" },
											"Physics"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_4" },
											"Statistics"
										)
									)
								),
								_react2.default.createElement(
									"div",
									{ className: "hiring-img" },
									_react2.default.createElement("img", { src: _seo4.default, alt: "Seo Image" })
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "row seo-row" },
								_react2.default.createElement(
									"div",
									{ className: "col-md-4 seo-img-container" },
									_react2.default.createElement(
										"div",
										{ className: "seo-img" },
										_react2.default.createElement("img", { src: _seo2.default, alt: "Seo Image" })
									)
								),
								_react2.default.createElement(
									"div",
									{ className: "col-md-8" },
									_react2.default.createElement(
										"p",
										null,
										"Recent articles from news sources list writing as a career choice which is almost recession-proof, because writing is a unique talent that requires focus and creativity. Writers are a valuable resource that many organizations overlook, undervalue, underpay, and utilize inappropriately. Jobs for freelance writers appear all over the internet, with many paying mere pennies per word, and many requiring a great deal of research or effort for little recognition or support from the company Writers, particularly freelance writers, are the basis for all online success. Writers supply the primary communication material that the internet utilizes - web content, articles, book reviews, student assistance, and a multitude of other written material. Here we value you as a supplier, which is why our writers are paid at higher rates than most other jobs for writers online."
									),
									_react2.default.createElement(
										"p",
										null,
										"Our organization was built by writers who recognized a need for freelancers to be placed with customers who truly needed their assistance. We do this at rates that warrant the best writing available. Unlike other jobs for writers, ours are based on your disciplines, your availability, and your preferences for earning. We work to match you with the work you want to do, and to provide you with all the administrative support you need to be successful as a writer. Professional freelance writers are the reason our company has become successful, and without you, our company would not exist. Because of this, we provide you with remuneration that can substantially benefit your family and your specific income needs. You can make as little or as much money as you want when you work for our company. We offer orders in multiple disciplines, different levels, and with different deadlines, based on availability. Unlike other jobs for freelance writers, you have choices which are nearly unlimited when you sign up to work with our company."
									),
									_react2.default.createElement(
										"h2",
										{ className: "inner-left-intext" },
										"We have a job for a freelance writer"
									),
									_react2.default.createElement(
										"p",
										null,
										"Professional writers with dedication and commitment to the writing they love are interested in making money from their writing. Many writers visit any number of freelance sites offering jobs for writers, but none of those sources pays nearly as much as our services do, because writers are the mainstay of our company \u2013 and we understand the work and education that has gone into your strengths and skills. We want you to succeed and continue to grow as a writer, and we pay you well to accomplish these goals, so that you can support your family and buy the things you want. You are part of the reason that freelance writing is a recession-proof job, and by joining our company, you can explore the benefits of being paid at the rates you want."
									),
									_react2.default.createElement(
										"p",
										null,
										"Give up the search for jobs for freelance writers and visit today. Sign up to be a part of something bigger \u2013 a company dedicated to meeting the needs of demanding customers. Our company will pay you to be a part of that solution. Here at ",
										_react2.default.createElement(
											_gatsbyLink2.default,
											{ to: "/" },
											"UVOCorp"
										),
										", you have the respect and commitment you deserve \u2013 from a company whose primary undertaking is matching up the needs presented to them with writers who fulfill them. Our pay is directly related to the level of professionalism, talent, and commitment to completing quality works. Our jobs for freelance writers are available based on your time to complete them, and we provide many opportunities for experienced writers to make even more money as they progress through the organization. You can have the best writing job, and we are here to provide you with remuneration and opportunity that are both competitive and appreciative of your talents. Visit today and start making the money you want, with UVOCorp."
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-registration inner-registration-left" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"div",
								{ className: "inner-registration-image" },
								_react2.default.createElement(
									"div",
									{ className: "img inner-registration-img" },
									_react2.default.createElement("img", { src: _registerNowLeft2.default, alt: "Start registration" })
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "inner-registration-text" },
								_react2.default.createElement(
									"div",
									{ className: "inner-registration-title" },
									"Register now ",
									_react2.default.createElement("br", null),
									"to start earning!"
								),
								_react2.default.createElement(
									"div",
									{ className: "inner-registration-button" },
									_react2.default.createElement(
										_gatsbyLink2.default,
										{ to: "/register_email.html" },
										"Start registration"
									)
								)
							)
						)
					),
					_react2.default.createElement(_footer2.default, null)
				),
				_react2.default.createElement("div", { id: "mask", className: "c-mask" })
			);
		};
	
		return Seo;
	}(_react2.default.Component);
	
	exports.default = Seo;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-jobs-for-writers-html-js-16bfa3cfcb3df039e7f1.js